import { render, staticRenderFns } from "./DishVisibilityFragment.vue?vue&type=template&id=1a0418f0&scoped=true"
import script from "./DishVisibilityFragment.vue?vue&type=script&lang=js"
export * from "./DishVisibilityFragment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0418f0",
  null
  
)

export default component.exports